export default __webpack_public_path__ + "static/media/1.4516e4cd.jpg";